// extracted by mini-css-extract-plugin
module.exports = {"zapaDark":"#074024","zapaMedium":"#0d7542","zapaLight":"#8ddd99","zapaTan":"#faf5e3","zapaWhite":"#fefdf8","zapaOrange":"#f8bd7f","zapaBlue":"#92aaff","zapaGray":"#4f4f4f"};